import React from 'react';
import './ContactUs.css';

const ContactUs = () => (
  <div className="contactus-root">
    <h2>?איך יוצרים איתנו קשר</h2>
    <p>
            .כאן בשבילך
      cazoty.min.tochnit@gmail.com
           – אם נח לך לכתוב 
    </p>
    <p>
      אם יותר קל לך לדבר - 053-4123358
    </p>
    <p>
        <span style={{color: "#ec529a", fontSize: "150%"}}>(:  </span>
      ואם את רק צריכה תמיכה טכנית, זה המקום - 054-8539868
    </p>
  </div>
);

export default ContactUs;
